<script>
import { updateSelection, getValue, isSelected } from '@/utils'

export default {
  functional: true,
  props: {
    item: Object,
    emitSelection: Function,
    selection: Array,
    headers: Array,
    actions: Array,
    hasActions: Boolean,
  },
  render: (h, { props }) => {
    const { headers, item, selection, emitSelection, hasActions, actions } = props
    let selected = isSelected(item, selection)
    let readState = item.read !== undefined ? item.read === 0 : false
    let isArchived = item.deleted_at !== undefined && item.deleted_at !== null
    const doSelect = (value) => { updateSelection(item, selection, value, emitSelection) }
    const tdClass = (header) => ({
      'px-1': true,
      'truncate': header['truncate'],
      'text-xs-right': header['align'] === 'right',
      'text-xs-left': header['align'] === 'left',
      'unread': readState,
    })
    let trClass = {
      'blue-grey lighten-2': isArchived,
    }
    let dataFields = headers.map((header, idx) => (
      <td key={ idx } class={ tdClass(header) } >{ getValue(item, header.value) }</td>
    ))
    let actionElems = hasActions && !isArchived
      ? actions.map((action, idx) => {
        const doCallBack = e => {
          action.callBack(item)
        }
        return (
          <v-btn icon class="mx-0 my-0" on-click={doCallBack}>
            <v-icon small >{action.icon}</v-icon>
          </v-btn>
        )
      })
      : null

    let actionItems = hasActions
      ? <td class="mx-0 px-0 text-xs-right">
        { actionElems }
      </td>
      : ''
    return (
      <tr class={trClass}>
        <td class="justify-start mx-0 layout pl-0 py-2 pr-0">
          <v-checkbox
            input-value={ selected }
            on-change={ doSelect }
          />
        </td>
        { dataFields }
        { actionItems }
      </tr>
    )
  },
}
</script>
<style scoped>
.truncate {
  max-width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
td.unread {
  font-weight: bold;
}
.v-input--selection-controls__input {
  background: black;
}
</style>
